import { ProviderStatusEnum } from '../../pages/constants';

export const PayorTypeOptions = [
  { id: 0, label: 'Medicare Part A' },
  { id: 1, label: 'Medicare Part B' },
  { id: 2, label: 'Medicaid' },
  { id: 3, label: 'Tricare' },
  { id: 4, label: 'ChampVa' },
  { id: 5, label: 'Group Health Plan' },
  { id: 6, label: 'FECA Blk Lung' },
  { id: 7, label: 'Other' },
];

export enum SupportedLanguages {
  English = 'en',
  Spanish = 'es',
}

export const BTTypeOptions = [
  { id: 0, label: 'BT' },
  { id: 1, label: 'RBT' },
  { id: 2, label: 'RLT' },
  { id: 3, label: 'CBT' },
];

export const EmploymentTypeOptions = [
  { id: 0, label: 'Contractor / 1099' },
  { id: 1, label: 'Hourly, full-time' },
  { id: 2, label: 'Hourly, part-time' },
  { id: 3, label: 'Salaried, full-time' },
];

export const ProviderTrainingStatusOptions = [
  { id: ProviderStatusEnum.NOT_TRAINING, label: 'Not In Training' },
  { id: ProviderStatusEnum.TRAINING, label: 'In Training' },
];

export const JobTitleOptions = [
  { id: 0, label: 'Behavior Technician' },
  { id: 1, label: 'Registered Behavior Technician' },
  { id: 2, label: 'Behavior Technician Trainee' },
  { id: 3, label: 'Virtual Therapy Assistant' },
  { id: 4, label: 'Lead Virtual Therapy Assistant' },
  { id: 5, label: 'Certified Behavioral Technician' },
  { id: 6, label: 'BCBA' },
  { id: 7, label: 'Lead BCBA' },
  { id: 8, label: 'Clinical Director' },
];

export const PayorSectorOptions = [
  { id: 0, label: 'Commercial' },
  { id: 1, label: 'MCO' },
  { id: 2, label: 'Medicaid' },
  { id: 3, label: 'Government Plan' },
];

export enum RelationshipToPolicyholder {
  Self = 'SELF',
  Spouse = 'SPOUSE',
  Child = 'CHILD',
  Other = 'OTHER',
}

export const DEFAULT_BILLING_FACILITY_LABEL = 'Montera Health TX LLC';

export enum ClinicalStatus {
  CLINICAL = 'CLINICAL',
  PRE_CLINICAL = 'PRE CLINICAL',
  OFFBOARDED = 'OFFBOARDED',
  ON_HOLD = 'ON HOLD',
}

export enum ProviderClinicalStatus {
  CLINICAL = 'CLINICAL',
  PRE_CLINICAL = 'PRE CLINICAL',
  OFFBOARDED = 'OFFBOARDED',
  ON_HOLD = 'ON HOLD',
  LIMITED_ACCESS_GUARDIAN = 'LIMITED ACCESS GUARDIAN',
  GUARDIAN_INVITED = 'GUARDIAN INVITED',
}

export enum ClientClinicalStatusReason {
  DISCHARGED = 'DISCHARGED',
  TERMINATED = 'TERMINATED',
  RESIGNED = 'RESIGNED',
}

export enum ProviderClinicalStatusReason {
  RESIGNED = 'RESIGNED',
  TERMINATED = 'TERMINATED',
}

export enum QaBillingStatus {
  BILLABLE = 'Billable',
  NOT_BILLABLE = 'Not Billable',
}

export const defaultServiceCodeDescriptions = {
  '97151': 'Assessment',
  '97152': 'Assisting Assessment',
  '97153': 'Direct ABA Technician 1:1',
  '97155': 'Protocol Modification by BCBA',
  '97156': 'Parent Training/Caregiver Support',
  '97157': 'Group Parent Training (2–8 parents in a group setting)',
  '99366': 'Care Coordination',
};

export const COHORT_PASSWORD_MIN_LENGTH = 12;
export const TEMP_PASSWORD_FOR_COHORTS = 'opnjhaJZBLo4';
